<template>
  <Card class="unlock-pro" :style="styles">
    <CardText>
      <VText variant="h2">Get Campsite Pro</VText>
      <ul>
        <li>
          😍
          <a
            href="https://support.campsite.bio/en/articles/6830835-adding-a-carousel-link"
            target="_blank"
            >Unlock carousel links</a
          >
        </li>
        <li>
          ⚙️
          <a
            href="https://support.campsite.bio/en/articles/6846362-adding-a-feed"
            target="_blank"
            >Auto-link: YouTube, Instagram + more</a
          >
        </li>
        <li>
          🔥
          <a
            href="https://support.campsite.bio/en/articles/6846550-how-to-set-up-a-custom-domain"
            target="_blank"
            >Use your custom domain</a
          >
        </li>
        <li>
          📩
          <a
            href="https://support.campsite.bio/en/articles/6840703-opt-in-form-link"
            target="_blank"
            >Collect newsletter or SMS opt-ins</a
          >
        </li>
        <li>
          🤓
          <a
            href="https://support.campsite.bio/en/articles/6848849-how-to-use-our-analytics"
            target="_blank"
            >Powerful analytics</a
          >
        </li>
        <li>
          🌐
          <a
            href="https://support.campsite.bio/en/articles/6827676-setting-up-custom-meta-tags"
            target="_blank"
            >Customize your metadata</a
          >
        </li>
      </ul>
      <Button
        style="margin-top: 1.5rem"
        href="https://app.campsite.bio/create-account?pro=true"
        target="_blank"
        color="secondary"
        >Start Your Free Trial</Button
      >
    </CardText>
  </Card>
</template>

<script>
import tinyColor from 'tinycolor2';
import {
  useTheme,
  Card,
  CardText,
  VText,
  Button,
} from '@campsite-bio/component-lib';
import { computed } from '@nuxtjs/composition-api';

export default {
  name: 'UnlockPro',

  components: {
    Card,
    CardText,
    VText,
    Button,
  },

  setup() {
    const theme = useTheme();

    const styles = computed(() => {
      return {
        '--c-bg-color': tinyColor(theme.value.colors.primary)
          .setAlpha(0.05)
          .toRgbString(),
      };
    });

    return { styles };
  },
};
</script>

<style lang="scss" scoped>
.unlock-pro.unlock-pro {
  background: var(--c-bg-color);
  border-radius: var(--g-border-radius-standard);
  border-radius: Min(
    var(--g-border-radius-standard),
    var(--g-border-radius-min)
  );
  margin: 2rem 0;

  h2 {
    margin: 0;
  }

  ul {
    list-style: none;
    margin: 1rem 0 0;
    padding: 0;

    @media (min-width: 544px) {
      columns: 2;
    }
  }

  li {
    padding: 0.2rem 0;
  }
}
</style>
